import { useMemo } from 'react';
import useUrl from 'utils/hooks/useUrl';
import EnumParams from './paths/params';

interface UseOrgUrlProps {
  baseUrl: string;
  orgId?: OrgId;
}

const useOrgUrl = ({ baseUrl, orgId }: UseOrgUrlProps) => {
  const replacers = useMemo(
    () => [{ placeholder: EnumParams.orgId, value: orgId?.toString() ?? '' }],
    [orgId]
  );
  return useUrl({
    url: baseUrl,
    replacers,
  });
};
export default useOrgUrl;
